export const percentOfValueFromValue = (firstValue: string, secondValue: string) =>
  (Number(firstValue) / Number(secondValue)) * 100;
